<template>
  <div>
    <v-row>
      <v-col
        v-for="{ u_reboq, u_matric, bostamp } in driverLoadOrdersTemplates"
        :key="bostamp" cols="12"
      >
        <v-autocomplete
          v-model="selectedMatric[bostamp]"
          :items="platesAll"
          :label="`${$t('fields.u_matric')} *`"
          outlined
          dense
        />
        <v-autocomplete
          v-model="selectedReboq[bostamp]"
          :items="trailers"
          :label="`${$t('fields.u_reboq')} *`"
          outlined
          dense
        />
        <v-btn
          block
          color="primary"
          x-large
          no-caps
          @click="clickBtn(bostamp)"
        >
          {{ $t('createWGt') }}
        </v-btn>
      </v-col>
    </v-row>
    <div
      class="mt-5 text-h5"
      v-if="driverLoadOrders.length > 0"
    >
      {{ $t('lastNOrders', { n: 15 }) }}
    </div>
    <v-data-table
      v-if="driverLoadOrders.length > 0"
      dense
      :headers="headers"
      :items="driverLoadOrders"
      item-key="bostamp"
      disable-pagination
      disable-sort
      hide-default-footer
    >
       <template v-slot:item.dataobra="{ value }">{{ formatUnix(value) }}</template>
    </v-data-table>
    <v-dialog
      v-model="confirmDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t('createWGt') }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDialog = false">{{ $t('no') }}</v-btn>
          <v-btn text color="primary" @click="confirmSubmit">{{ $t('yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import functions from '@/resources/functions';

export default {
  mixins: [functions],
  metaInfo() {
    return {
      title: this.$t('createOrder'),
    };
  },
  data() {
    return {
      activeBostamp: null,
      confirmDialog: false,
      selectedMatric: {},
      selectedReboq: {},
      headers: [
        {
          text: this.$t('fields.dataobra'),
          value: 'dataobra',
        },
        {
          text: this.$t('fields.u_matric'),
          value: 'u_matric',
        },
        {
          text: this.$t('fields.u_reboq'),
          value: 'u_reboq',
        },
        {
          text: this.$t('fields.atcodeid'),
          value: 'at_document.atcodeid',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('loadOrders', ['driverLoadOrders', 'driverLoadOrdersTemplates', 'platesAll', 'trailers']),
    ...mapGetters(['isLoading']),
  },
  methods: {
    ...mapActions('loadOrders', ['showDriverLoadOrders', 'showDriverLoadOrdersTemplates', 'createDriverLoadOrder', 'showPlatesAll', 'showTrailersAll']),
    ...mapMutations(['setLoading']),
    setDefaultSelectedMatric() {
      this.driverLoadOrdersTemplates.forEach(({ bostamp, u_matric: uMatric }) => {
        this.$set(this.selectedMatric, bostamp, uMatric);
      });
    },
    setDefaultSelectedReboq() {
      this.driverLoadOrdersTemplates.forEach(({ bostamp, u_reboq: uReboq }) => {
        this.$set(this.selectedReboq, bostamp, uReboq);
      });
    },
    clickBtn(bostamp) {
      this.activeBostamp = bostamp;

      this.confirmDialog = true;
    },
    async confirmSubmit() {
      this.setLoading(true);

      const bostamp = this.activeBostamp;

      const payload = {
        bostamp,
        u_matric: this.selectedMatric[bostamp],
        u_reboq: this.selectedReboq[bostamp],
      };

      try {
        await this.createDriverLoadOrder(payload);

        await this.showDriverLoadOrders();

        this.confirmDialog = false;
      } finally {
        this.setLoading(false);
      }
    },
  },
  async mounted() {
    this.setLoading(true);

    await this.showDriverLoadOrders();

    await this.showPlatesAll();

    await this.showTrailersAll();

    await this.showDriverLoadOrdersTemplates();

    this.setDefaultSelectedMatric();

    this.setDefaultSelectedReboq();

    this.setLoading(false);
  },
};
</script>
